import { render } from "./AlertsFilters.vue?vue&type=template&id=129b9e8f&ts=true"
import script from "./AlertsFilters.vue?vue&type=script&lang=ts"
export * from "./AlertsFilters.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__